import React from 'react';
import { Grid } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/AttributionManager/messages';
import { translate } from 'containers/services/translate';
import Dialog from 'containers/AttributionManager/Dialogs/index';
import {
  StyleDescriptionDialog,
  StyleTitleDialog,
} from 'containers/AttributionManager/styles';
export interface ConfirmationUnassignedManagerDialogProps {
  intl: IntlShape;
  confirmationDialog: boolean;
  handleCloseConfirmationDialog: any;
  handleValidate: any;
}

export const ConfirmationUnassignedManagerDialog: React.FC<ConfirmationUnassignedManagerDialogProps> = (
  props,
): JSX.Element => {
  return (
    <Dialog
      open={props.confirmationDialog}
      onClose={props.handleCloseConfirmationDialog}
      validateDialog={props.handleValidate}
      title={''}
      content={
        <Grid container direction="column">
          <Grid item style={{ marginBottom: '30px' }}>
            <span style={StyleTitleDialog}>
              {translate(messages.unassignedManagerDialogTitle, props)}
            </span>
          </Grid>
          <Grid item>
            <span style={StyleDescriptionDialog}>
              {translate(messages.confirmationDialogDescription, props)}
            </span>
          </Grid>
        </Grid>
      }
      disabled={false}
    />
  );
};

export default injectIntl(ConfirmationUnassignedManagerDialog);
